<div class="app-page-header-container">
  <div class="app-page-header" [ngClass]="AppConfig.theme">
    <ng-content></ng-content>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/page/page-header/page-header.component.html